export default __webpack_public_path__ + "static/media/firecracker.12b7b39b.svg";